import Microgame from '../engine/Microgame.js';

export default class FlickGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Balance !`, en: `Flick!`, es: `¡Lanza!` },
            controls: { fr: `Mets un petit coup sec (swipe rapide) sur l'objet`, en: `Give the object a quick flick (fast swipe)`, es: `Da un golpe rápido al objeto (desliza rápido)` },
            objective: { fr: `Envoie l'objet valser le plus loin possible`, en: `Flick the object away as far as possible`, es: `Lanza el objeto lo más lejos posible` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--secondary-color)" stroke-width="2"><path d="M12 19V5M5 12l7-7 7 7"/></svg>`,
            actions: [
                { type: 'wait', duration: 240 },
                { type: 'swipe', fromX: 50, fromY: 84, toX: 62, toY: 18, duration: 340 },
                { type: 'wait', duration: 760 },
            ],
            loopDuration: 2600
        };
    }
    constructor(engine) {
        super(engine);
        this.ball = null;
        this.startY = 0;
        this.startX = 0;
        this.isDragging = false;
        this._isAnimating = false;
        this._frozenTimerValue = 0;
    }

    update(dt) {
        if (this._isAnimating) {
            this.engine.timer = this._frozenTimerValue;
        }
    }

    setup() {
        this.engine.ui.instruction.textContent = "AIM!";

        const width = this.container.getBoundingClientRect().width || window.innerWidth;
        const height = this.container.getBoundingClientRect().height || window.innerHeight;
        this.screenWidth = width;
        this.screenHeight = height;

        this.targetLeftPct = this.isPlayback ? 62 : (20 + Math.random() * 60); // 20% to 80%

        // Basket (Secondary)
        this.goal = document.createElement('div');
        this.goal.style.position = 'absolute';
        this.goal.style.width = '120px';
        this.goal.style.height = '80px';
        this.goal.style.border = `4px solid ${this.secondaryColor}`;
        this.goal.style.borderTop = 'none';
        this.goal.style.borderRadius = '0 0 40px 40px';
        this.goal.style.top = '15%';
        this.goal.style.left = `${this.targetLeftPct}%`;
        this.goal.style.transform = 'translateX(-50%)';
        this.goal.style.boxShadow = `0 5px 15px ${this.secondaryColor}`;
        this.container.appendChild(this.goal);

        // Paper Airplane Wrapper (Primary)
        this.ball = document.createElement('div');
        this.ball.style.position = 'absolute';
        this.ball.style.width = '60px';
        this.ball.style.height = '80px';
        this.ball.style.bottom = '15%';
        this.ball.style.left = '50%';
        this.ball.style.transform = 'translate(-50%, 0)';
        this.ball.style.filter = `drop-shadow(0 0 10px ${this.primaryColor})`;
        this.ball.style.cursor = 'grab';
        
        // Plane Shape (Clipped)
        const plane = document.createElement('div');
        plane.style.width = '100%';
        plane.style.height = '100%';
        plane.style.background = this.primaryColor;
        plane.style.clipPath = 'polygon(50% 0%, 100% 100%, 50% 80%, 0% 100%)';
        this.ball.appendChild(plane);

        // Expanded Hitbox
        const hitbox = document.createElement('div');
        hitbox.style.position = 'absolute';
        hitbox.style.width = '160px';
        hitbox.style.height = '160px';
        hitbox.style.top = '50%';
        hitbox.style.left = '50%';
        hitbox.style.transform = 'translate(-50%, -50%)';
        hitbox.style.cursor = 'inherit';
        this.ball.appendChild(hitbox);

        this.container.appendChild(this.ball);

        this.onDown = this.onDown.bind(this);
        this.onUp = this.onUp.bind(this);

        this.ball.addEventListener('pointerdown', this.onDown);
        this.engine.input.element.addEventListener('pointerup', this.onUp);
    }

    onDown(e) {
        if (this.won || this.lost) return;
        this.isDragging = true;
        this.startX = e.clientX;
        this.startY = e.clientY;
        this.ball.style.cursor = 'grabbing';
    }

    onUp(e) {
        if (!this.isDragging || this.won || this.lost) return;
        this.isDragging = false;
        this.ball.style.cursor = 'grab';

        const dx = e.clientX - this.startX;
        const dy = e.clientY - this.startY;

        // Check Flick (Swipe Up)
        if (dy < -30) { 
            // Freeze timer
            this._isAnimating = true;
            this._frozenTimerValue = this.engine.timer;

            // Calculate trajectory
            // We want to project the line to the target Y (which is 15% from top, ball is at 85% from top)
            // vertical distance = roughly 70% of screen height
            const planeTravelY = this.screenHeight * 0.70;
            const ratio = dx / Math.abs(dy); // dx per 1px up
            const projectedDx = ratio * planeTravelY;
            
            // Animate flight
            this.ball.style.transition = 'all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
            this.ball.style.bottom = '85%';
            // Limit the rotation angle visuals
            const visualRotation = Math.max(-60, Math.min(60, ratio * 45));
            this.ball.style.transform = `translate(calc(-50% + ${projectedDx}px), 0) rotate(${visualRotation}deg) scale(0.5)`;

            // Check Aim
            const finalX = (this.screenWidth / 2) + projectedDx;
            const targetX = (this.targetLeftPct / 100) * this.screenWidth;
            
            if (Math.abs(finalX - targetX) < 70) {
                setTimeout(() => {
                    this.win();
                    this.ball.style.transition = 'all 0.2s ease-in';
                    this.ball.style.bottom = '80%';
                    this.ball.style.opacity = '0';
                }, 400);
            } else {
                setTimeout(() => this.lose(), 500);
            }
        }
    }

    cleanup() {
        super.cleanup();
        if (this.ball) this.ball.removeEventListener('pointerdown', this.onDown);
        this.engine.input.element.removeEventListener('pointerup', this.onUp);
    }
}
